import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOneEnquire, updateEnquire } from 'slice/enquireSlice';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oneData: enquire, loading } = useSelector((state) => state.enquire);

    const [status, setStatus] = useState('');

    useEffect(() => {
        dispatch(getOneEnquire(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (enquire) {
            setStatus(enquire.status);
        }
    }, [enquire]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateEnquire({ id, data: { status } }));
        navigate('/khajuraho/enquiries');
    };

    if (loading || !enquire) {
        return <div className="p-5 text-center">Loading enquiry details...</div>;
    }

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Enquiry Status</h4>
            </div>
            <div className="mt-4 px-4 bg-white rounded shadow-sm py-4 max-w-lg mx-auto">
                <div className="mb-4">
                    <h5 className="font-weight-bold">Enquiry Details</h5>
                    <hr />
                    <div className="grid grid-cols-2 gap-2 text-sm">
                        <p><strong>Name:</strong> {enquire.name}</p>
                        <p><strong>Phone:</strong> {enquire.number || enquire.phone || enquire.mobile}</p>
                        <p><strong>Email:</strong> {enquire.email}</p>
                        <p><strong>City:</strong> {enquire.city || '-'}</p>
                        <p><strong>Travelers:</strong> {enquire.travelers || '-'}</p>
                        <p><strong>Travel Date:</strong> {enquire.travelDate || '-'}</p>
                    </div>
                    <div className="mt-3">
                        <p><strong>Message/Requirements:</strong></p>
                        <div className="p-3 bg-light rounded border text-muted">
                            {enquire.message}
                        </div>
                    </div>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="enquiryStatus" className="font-weight-bold">Enquiry Status</label>
                        <select 
                            id="enquiryStatus"
                            className="form-control" 
                            value={status} 
                            onChange={(e) => setStatus(e.target.value)}
                            required
                        >
                            <option value="pending">Pending</option>
                            <option value="resolved">Resolved</option>
                            <option value="cancelled">Cancelled</option>
                        </select>
                    </div>
                    <div className="mt-4">
                        <button type="submit" className="btn btn-primary px-5 mr-3">Update Status</button>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/khajuraho/enquiries')}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Update;
